import { ReactElement, memo } from 'react';
import { useTranslation } from 'next-i18next';
import { usePreference } from '@utmb/contexts/PreferenceContext';
import { UnitEnum } from '@utmb/types/unit-enum';
import { IconsEnum } from '@utmb/types/icons';
import { SelectPopin } from '@utmb/design-system/select-popin/SelectPopin';

interface Props {
    className?: string;
    /** Rendered in the mobile menu (adds a chevron to the trigger). */
    isMobile?: boolean;
}

export const MyParameters = memo((props: Props): ReactElement => {
    const { t } = useTranslation();

    const {
        preferences: { preferredUnit },
        setPreferredUnit,
    } = usePreference();

    return (
        <SelectPopin<UnitEnum>
            className={props.className}
            icon={IconsEnum.RULER}
            withChevron={props.isMobile}
            triggerLabel={preferredUnit === UnitEnum.IMPERIAL ? 'miles' : 'km'}
            ariaLabel={t('common.pref.unit.title')}
            title={t('common.pref.unit.title')}
            options={[
                { value: UnitEnum.METRIC, label: `${t('common.pref.unit.metric')} (km / m)` },
                { value: UnitEnum.IMPERIAL, label: `${t('common.pref.unit.imperial')} (miles / feet)` },
            ]}
            value={preferredUnit}
            onSelect={setPreferredUnit}
        />
    );
});
